const ContractFragment = `
    id
    contractAddress
    chain
    status
`

export default ContractFragment
